import { Box } from '@src/atoms/Box';
import { List } from '@src/atoms/List';
import React, { useEffect, useRef, useState } from 'react';

import styled from './BonusesDescription.module.scss';
import { useThrottle } from '@src/hooks/useThrottle';
import { AnyType } from '@src/models/common';

export const BonusesDescription = ({ bonusesDescription }) => {
  const containerRef = useRef(null);
  const [showBottomShadow, setShowBottomShadow] = useState(true);
  const [showTopShadow, setShowTopShadow] = useState(false);
  const [hasScroll, setHasScroll] = useState(false);

  const handleScroll = useThrottle((event) => {
    if (!hasScroll) return;
    const divEvent = event as AnyType;

    if (!divEvent.currentTarget) return;

    const { scrollTop, scrollHeight, clientHeight } = divEvent.currentTarget;

    const isBottom = scrollTop + clientHeight >= scrollHeight - 30;
    const isTop = scrollTop <= 30;
    setShowBottomShadow(!isBottom);
    setShowTopShadow(!isTop);
  }, 10);
  useEffect(() => {
    if (containerRef.current) {
      const { scrollHeight, clientHeight } = containerRef.current;
      const hasScrollNow = scrollHeight > clientHeight;
      setHasScroll(hasScrollNow);

      // Если скролла нет, скрываем обе тени
      if (!hasScrollNow) {
        setShowBottomShadow(false);
        setShowTopShadow(false);
      }
    }
  }, [bonusesDescription]);

  return (
    <Box className={styled.root}>
      {showTopShadow && <Box className={styled.topShadow} />}
      <Box className={styled.container} onScroll={handleScroll} ref={containerRef}>
        <List className={styled.list}>
          {bonusesDescription?.map((r) => (
            <List.Item key={r}>{r}</List.Item>
          ))}
        </List>
      </Box>
      {showBottomShadow && <Box className={styled.bottomShadow} />}
    </Box>
  );
};
